import ReserveDate from "components/Safra/SearchComponents/ReserveDate";
import RoomQuantity from "components/Safra/SearchComponents/RoomQuantity";
import Offers from "components/Safra/SearchComponents/Offers"
import SearchLocation from "components/SearchComponents/SearchLocation";
import SearchHotelName from "components/SearchComponents/SearchHotelName";

import {changeLocationsHotelAction, changeOfferHotelAction, changeHotelNameAction} from "contexts/reducers/hotels/actions";
import { useApp } from "contexts/AppContext";
import { useGenialApp } from "contexts/GenialAppContext";
import { useTranslation } from "contexts/Safra/TranslationContext";
import {isChannel} from "../../../utils";


export default function () {
    const { t } = useTranslation();
    const { hotelState, hotelDispatch } = useApp()
    const { offersHotel, locationSearchHotel, hotelNameSearch, datesSearchHotel } = hotelState

    const searchLocation = (local) => {
        const previousLocationId = locationSearchHotel?.id;
        const nextLocationId = local?.id;
        const hasValidLocation = Boolean(nextLocationId);
        const locationChanged = Boolean(previousLocationId && nextLocationId && previousLocationId !== nextLocationId);

        hotelDispatch(changeLocationsHotelAction(local))

        if (!hasValidLocation || locationChanged) {
            hotelDispatch(changeHotelNameAction({ id: undefined, name: '' }))
        }
    }

    const changeOffers = (offers) => {
        hotelDispatch(changeOfferHotelAction(offers))
    }

    const changeHotelName = (hotel) => {
        hotelDispatch(changeHotelNameAction(hotel))
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%', padding: '16px 0px' }}>
            <SearchLocation
                placeholder={t('safra.home.fields.destination')}
                variant="hotel"
                location={ locationSearchHotel }
                onChange={searchLocation}
            />

            <SearchHotelName
                placeholder={t('safra.components.search_hotel.hotel_name_placeholder')}
                disabled={!locationSearchHotel?.id}
                hotel={hotelNameSearch}
                onChange={changeHotelName}
            />

            <ReserveDate
                placeholderStart={t('safra.home.fields.checkin')}
                placeholderEnd={t('safra.home.fields.checkout')}
                boxed={true}
                initialDates={{
                    startDate: datesSearchHotel?.startDate || null,
                    endDate: datesSearchHotel?.endDate || null,
                }}
            />

            <RoomQuantity />
        </div>
    )
}
